import React, { useEffect, useRef, useState } from "react";
import {
  IFilterDispositivosAsignados,
  IFilterReporteDispositivoAsignado,
  initFiliterDispositivosAsigandos,
  initialFilterReporteDispositivoAsignado,
} from "../../Interfaces/DispositivoAsignado/IDispositivoAsignado";
import dispositivoAsignadoService from "../../services/dispositivo/dispositivoAsignadoService";
import { IDispositivo } from "../../Interfaces/IDispositivos";
import { _formatDate } from "../../utils/helpers/dateHelpers";
import { ISearchBox } from "@fluentui/react";
import { IPaginacion } from "../../Interfaces/filter";
import { IException } from "../../Interfaces/base/IBase";
interface IFilterFechasDate {
  filterFechaInicio: Date | undefined;
  filterFechaFin: Date | undefined;
}
export const useTableDispositivoAsignados = () => {
  const controllerRefAbort = useRef<AbortController>(new AbortController());
  const [control, setControl] = useState(false)
  const [filter, setFilter] = useState<IFilterDispositivosAsignados>(
    initFiliterDispositivosAsigandos
  );
  const [filterReporte, setFilterReporte] =
    useState<IFilterReporteDispositivoAsignado>(
      initialFilterReporteDispositivoAsignado
    );
  const [filterFechas, setFilterFechas] = useState<IFilterFechasDate>({
    filterFechaInicio: new Date(),
    filterFechaFin: new Date(),
  });
  const searchBoxRefTable = useRef<ISearchBox>(null);

  const _onkeyUpSearchDispositivo = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [itemsTable, setItemsTable] = useState<IDispositivo[]>([]);
  const [loading, setLoading] = useState(false);

  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        const cambiarFechaFin = date < (filterFechas.filterFechaFin as Date) ? (filterFechas.filterFechaInicio as Date) : date;

        setFilterFechas({ ...filterFechas, filterFechaInicio: date, filterFechaFin: cambiarFechaFin });
        setFilter({ ...filter, fechaEntregaInicio: _formatDate(date, ","), fechaEntregaFin: _formatDate(cambiarFechaFin, ",") });
        setFilterReporte({
          ...filterReporte,
          fechaEntregaInicio: _formatDate(date, ","),
          fechaEntregaFin: _formatDate(cambiarFechaFin, ","),
        });
        break;
      case "fin":
        setFilter({ ...filter, fechaEntregaFin: _formatDate(date, ",") });
        setFilterFechas({ ...filterFechas, filterFechaFin: date });
        setFilterReporte({
          ...filterReporte,
          fechaEntregaFin: _formatDate(date, ","),
        });
        break;
      default:
        break;
    }
  };
  const onChangeComboBox = (event, o, text) => {
    if (event !== undefined) {
      // if (o && o.key) {
      switch (text) {
        case "guardia":
          if (o?.key) {
            setFilter({ ...filter, guardia: o.key });
            setFilterReporte({
              ...filterReporte,
              guardia: o.key,
            });
          }
          break;
        case "area":
          if (o?.key) {
            setFilter({ ...filter, areaId: o.key });
          }
          break;
        default:
          break;
      }
      // }

    }
  };

  const postTablaDispositivoAsignados = () => {
    setLoading(true);
    controllerRefAbort.current.abort();
    const newController = new AbortController();
    controllerRefAbort.current = newController;
    dispositivoAsignadoService
      .allDispositivosAsignados(filter, newController)
      .then((res) => {
        if (res.status === 200) {
          setItemsTable(res.data.items);
          setPaginacion({
            page: res.data.page,
            total: res.data.total,
            pages: res.data.pages,
          });
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err: IException) => {
        setLoading(false);
        console.log(err);
      });
  };

  const limpiarFiltro = () => {
    setFilter(initFiliterDispositivosAsigandos);
    setFilterReporte(initialFilterReporteDispositivoAsignado);
    setFilterFechas({
      ...filterFechas,
      filterFechaFin: new Date(),
      filterFechaInicio: new Date(),
    });
    setControl(true)
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;

      default:
        break;
    }
  };
  const actualizarTabla = () => {
    postTablaDispositivoAsignados();
  };

  useEffect(() => {
    if (control) {
      postTablaDispositivoAsignados();
      setControl(false)
    }
  }, [control])
  // useEffect(() => {
  //   postTablaDispositivoAsignados();
  // }, [filter]);

  return {
    loading,
    _onkeyUpSearchDispositivo,
    searchBoxRefTable,
    filter,
    filterReporte,
    itemsTable,
    _onSelectDate,
    onChangeComboBox,
    actualizarTabla,
    limpiarFiltro,
    paginacion,
    filterFechas,
    onChangeSkip,
    postTablaDispositivoAsignados
  };
};
